export const SEOCheckerApp = () => {
//TODO:send first hidden message with job definition in backend and get chatID 
    return(<></>)
}

export default SEOCheckerApp;

